import owner1 from '../images/owner1.png'
import owner2 from '../images/owner2.png'
import owner3 from '../images/owner3.png'
import owner4 from '../images/owner4.png'
import owner5 from '../images/owner5.png'
import owner6 from '../images/owner6.png'

import appe1 from '../images/appe1.png'
import appe2 from '../images/appe2.png'
import appe3 from '../images/appe3.png'
import appe4 from '../images/appe4.png'
import appe5 from '../images/appe5.png'
import appe6 from '../images/appe6.png'

export const cardsData = [
    {
        id: 0,
        owner: '@knight',
        img: owner1,
        nftImage:appe1
    },
    {
        id: 0,
        owner: '@knight',
        img: owner2,
        nftImage:appe2
    },
    {
        id: 0,
        owner: '@knight',
        img: owner3,
        nftImage:appe3
    },
    {
        id: 0,
        owner: '@knight',
        img: owner4,
        nftImage:appe4
    },
    {
        id: 0,
        owner: '@knight',
        img: owner5,
        nftImage:appe5
    },
    {
        id: 0,
        owner: '@knight',
        img: owner6,
        nftImage:appe6
    },
]